import { render } from "./LeftSidebar.vue?vue&type=template&id=c429ca8e&scoped=true"
import script from "./LeftSidebar.vue?vue&type=script&lang=js"
export * from "./LeftSidebar.vue?vue&type=script&lang=js"

import "./LeftSidebar.vue?vue&type=style&index=0&id=c429ca8e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c429ca8e"]])

export default __exports__